
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Logo from "../components/Logo.vue";

@Component({
  components: {
    Logo
  }
})
export default class TopNav extends Vue {
  @Prop() compact?: boolean;
}
